import FormSort from './form-sort.jsx';

export {FormSort}


// WEBPACK FOOTER //
// ./src/components/modules/reception/form-sort/index.js